<template>
  <el-dialog v-dialogDrag :visible.sync="catalogDialogVisible" title="选择目录模式" width="500px" :close-on-click-modal="false" :close-on-press-escape="false">
    <el-form ref="form" label-position="top" size="small">
      <el-row>
        <el-col :span="24">
          <el-form-item label="请先选择您想要的目录信息和层级关系">
            <el-select v-model="orderKey" placeholder="请选择" size="small" style="width: 100%" @change="catalogChange">
              <el-option v-for="(item, index) in orderRuleList" :key="index" :label="item.orderName"
                :value="item.orderCode">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <span slot="footer" class="dialog-footer">
      <el-button size="small" @click="catalogDialogVisible = false">取 消</el-button>
      <el-button v-preventReClick type="primary" size="small" @click="initCatalog">确 定</el-button>
    </span>
  </el-dialog>
</template>
<script>
export default {
  props: {
    orderRuleList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      catalogDialogVisible: false,
      orderKey: ""
    };
  },

  methods: {
    show() {
      this.catalogDialogVisible = true;
    },

    catalogChange() {

    },

    initCatalog() {
      if (!this.orderKey) {
        this.$error("请选择一个层级关系");
        return;
      }
      this.catalogDialogVisible = false;
      this.$emit("ok", this.orderKey);
    }
  }
};
</script>
